import React from "react";
import {GeneriskAction, GeneriskModel} from "../GeneriskeRapporter/update";
import {UIModel} from "../../update/ui";
import {AppState} from "../../types";
import {SubmitButton} from "@nvdb-rapport/shared/src/styled/Button";

interface SubmitProps {
  generiskState: GeneriskModel;
  generiskDispatch: React.Dispatch<GeneriskAction>;
  uiState: UIModel;
  formIsValid: boolean;
}

export default function Submit({
  generiskState,
  generiskDispatch,
  uiState,
  formIsValid,
}: SubmitProps) {
  if (generiskState.selectedReportType.isNothing()) {
    return null;
  }

  if (uiState.appState === AppState.APP_READY || uiState.appState === AppState.DATA_READY) {
    return (
      <SubmitButton
        style={{ marginTop: "3rem" }}
        aria-disabled={!formIsValid}
        onFocus={() => {
          generiskDispatch({
            type: "ShowValidationErrors",
            payload: true,
          })
        }}
        type="submit"
      >
        {uiState.appState === AppState.APP_READY && "Hent data"}
        {uiState.appState === AppState.DATA_READY && "Nytt søk"}
      </SubmitButton>
    )
  }

  return null;
}